



























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { MatrixRowModel, ItemValue, QuestionMatrixModel } from "survey-core";

@Component
export class MatrixCell extends Vue {
  @Prop() question: QuestionMatrixModel;
  @Prop() row: MatrixRowModel;
  @Prop() column: ItemValue;
  @Prop() columnIndex: number;
}
Vue.component("survey-matrix-cell", MatrixCell);
export default MatrixCell;
